<template>
  <div class="tab-inner-left">
    <div class="form-module">
      <h2>Survey Card</h2>
      <p>Please enter the questions and options you request for the survey card.</p>
      <div v-show="showError" class="text-danger py-2">No question found</div>
      <div class="question" v-for="(question, index) in questionList" :key="index">
        <h3>Question</h3>
        <span v-if="errors.has(`question_${index+1}`)" class="text-danger">{{ errors.first(`question_${index+1}`).replace(`question_${index+1}`, 'Question Name') }}</span>
        <div class="descripted">
          <input class="al-input" type="text" placeholder="Question here"
                 @input="questionNameChange(question, $event)"
                 :ref="`question_${index+1}`" :name="`question_${index+1}`"
                 :data-vv-name="`question_${index+1}`"
                 :value="question.name"
                 v-validate="question.name !== '' ? '' : 'required'">
        </div>
        <h4>Options</h4>
        <span v-if="errors.has(`question_${index+1}`)" class="text-danger">{{ errors.first(`question_${index+1}`).replace(`question_${index+1}`, 'Question Name') }}</span>
        <div class="descripted">
          <input class="al-input" type="text" placeholder="Option here"
                 @input="questionNameChange(options, $event)"
                 :ref="`question_options_${index+1}`" :name="`question_options_${index+1}`"
                 :data-vv-name="`question_options_${index+1}`"
                 :value="options"
                 v-validate="question.options.name !== '' ? '' : 'required'">
        </div>
        <label class="remove al-button remove-prize red-button" @click="deleteQuestion(question)">
          <i class="fas fa-trash"></i> Delete Question
        </label>
        <div class="al-button orange-button w40 option"  @click="addOption"><i class="fas fa-plus"></i> Add Option</div>

      </div>
      <div class="add-more al-button"  @click="addQuestion"><i class="fas fa-plus"></i> Add More Question</div>
    </div>
  </div>
</template>

<script>

import UploadImage from '../../../../layouts/components/navbar/UploadImage'
export default {
  props: {
    update: {
      type: Function
    },
    dataVal: {
      type: Object
    },
    id: {
      type: String
    }
  },
  data () {
    return {
      create: true,
      showError: false,
      dataImg: require('@/assets/images/logo/logo.png'),
      uploadImg: null,
      name: '',
      logo_id: '',
      title: '',
      offer: '',
      campaign_image_id: '',
      fieldnames: [
        {
          name: 'Name',
          type: 'text',
          code: 'name',
          value: false
        },
        {
          name: 'Phone Number',
          code: 'phone',
          type: 'phone',
          value: false
        },
        {
          name: 'Email',
          code: 'email',
          type: 'email',
          value: true
        },
        {
          name: 'Birthday',
          code: 'birthday',
          type: 'date',
          value: false
        },
        {
          name: 'ZIP Code',
          code: 'address',
          type: 'text',
          value: false
        }
      ],
      fieldList: [],
      questionList: [],
      questionDefault: {
        name: '',
        options: []
      },
      options: '',
      campaign_name_focused: false,
      campaign_slogan_focused: false,
      campaign_award_focused: false,
      daysOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
    }
  },
  components: {
    UploadImage
  },
  provide () {
    return {
      $validator: this.$validator
    }
  },
  mounted () {
    this.set_data()
  },
  watch: {
    campaign_name_focused () {
      this.update_data()
    },
    dataVal () {
      this.set_data()
    },
    questionList () {
      this.update_data()
    }
  },
  computed: {
    post_detail () {
      return this.$store.state.post_detail
    }
  },
  methods: {
    showValidationError () {
      this.showError = true
      setTimeout(() => {
        this.showError = false
      }, 5000)
    },
    questionNameChange (question, e) {
      question.name = e.target.value
      this.update_data()
    },
    openConfirm (accept, cancel) {
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: 'Confirm',
        text: 'Are you sure you want to delete this item?',
        accept,
        cancel
      })
    },
    deleteQuestion (question) {
      this.openConfirm(() => {
        const index = this.questionList.indexOf(question)
        this.questionList.splice(index, 1)
        this.update_data()
      }, () => {})

    },
    addQuestion () {
      this.questionList.push({
        name: '',
        options: []
      })
      console.log(this.questionList)
    },
    addOption () {
      this.questionList.push({
        name: '',
        options: []
      })
      console.log(this.questionList)
    },
    set_data () {
      const { questionList } = JSON.parse(JSON.stringify(this.dataVal))
      console.log('questionlist', JSON.parse(JSON.stringify(this.dataVal)))
      this.questionList = questionList
      console.log('setting data', this.dataVal)
    },
    update_data (ref) {
      this.update(this.questionList)
      this.$store.commit('SET_EDITING_NOW', ref)
    }
  }
}
</script>

<style lang="scss">
.question {
  padding: 10px;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 7px;
  margin: 20px 0;
}
.prize{
  position:relative;
  .remove-prize{
    position:absolute;
    top:0;
    right:-24px;
    transform:scale(0.6);
  }
}
.days-of-week .day-of-week {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.days-of-week label {
  margin-left: 8px;
  margin-right: 16px; /* Label ve sonraki input elementi arasında boşluk */
}
.day-selection {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  background: #fff;
  padding: 0 10px;
  color: #728a9a;
  position:relative;

  input[type="checkbox"] {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    position: relative;
    width: 20px;
    height: 20px;
    cursor: pointer;
    outline: none;
    margin-right: 10px;
    border: 1px solid #cccccc;
    border-radius: 0px;
    background-color: #fff;
  }
  input[type="checkbox"]:checked::before {
    content: '';
    position: absolute;
    left: 5px;
    top: 0px;
    width: 8px;
    height: 15px;
    border: solid #0d3652; /* Checkmark color */
    border-width: 0 5px 5px 0;
    transform: rotate(45deg);
  }
  input[type="checkbox"]:checked {
    border-color: #0d3652;
  }
  input[type="checkbox"]:hover {
    background-color: #f0f0f0;
  }
  label{
    font-size:28px;
  }
  .orange-border{
    width:8px;
    height:42px;
    background-color:#ff7422;
    display:block;
    position:absolute;
    right:0;
  }
}
.question{
  position:relative;
  .remove-prize{
    position:absolute;
    top:0;
    right:-24px;
    transform:scale(0.6);
  }
  .option{
    position:absolute;
    top:0;
    right:90px;
    transform:scale(0.6);
  }
}
</style>
